import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ProDriverSupplierReportItem = ResultOf<
  typeof proDriverSupplierReportQuery
>["proDriverSupplierReport"][number];

export const proDriverSupplierReportQuery = graphql(`
  query ProDriverSupplierReport(
    $rangeStartDate: String!
    $rangeEndDate: String!
  ) {
    proDriverSupplierReport(
      range_start_date: $rangeStartDate
      range_end_date: $rangeEndDate
    ) {
      supplier_id
      supplier_name
      total_work_orders
      total_assignments
      total_invoice_amount_aud
      total_claimed_expenses_aud
      total_expected_payout_aud
      total_payouts_aud
      total_profit_aud
      avg_profit_per_work_order_aud
      avg_payout_per_driver_aud
      won_count
      lost_count
    }
  }
`);

export type ProDriverSupplierCityMovement = ResultOf<
  typeof proDriverSupplierCityMatrixQuery
>["proDriverSupplierCityMatrix"][number];

export const proDriverSupplierCityMatrixQuery = graphql(`
  query ProDriverSupplierCityMatrix(
    $supplierId: ID!
    $rangeStartDate: String!
    $rangeEndDate: String!
  ) {
    proDriverSupplierCityMatrix(
      supplier_id: $supplierId
      range_start_date: $rangeStartDate
      range_end_date: $rangeEndDate
    ) {
      departure_city
      delivery_city
      count
    }
  }
`);
